import React from 'react'
// import EditPlants from '../features/nursery/Components/PlantsForms/EditPlants'

const EditPlantsPage = () => {
  return (
    <>
    <div className='d-flex justify-content-center align-items-center py-5'>
      <p className='h1' style={{fontFamily: "cursive"}}>We are working on it...</p>
    </div>
    {/* <EditPlants /> */}
    </>
  )
}

export default EditPlantsPage